import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { getApiData } from "../../../../../utils/APIHelper";
import { Setting } from "../../../../../utils/Setting";
import { toast } from "react-toastify";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  styled,
  Typography,
} from "@mui/material";
import { ReactComponent as SmallDhiramIcon } from "../../../../../assets/svg/SmallDhiramIcon.svg";
import { renderCurrencyIcon } from "../../../../../utils/CurrencyUtils";
import { ReactComponent as DhiramIcon } from "../../../../../assets/svg/DhiramIcon.svg";
import { formattedAmountWithoutAed } from "../../../../../utils/CommonFunction";
import moment from "moment";
import { statusStyleArray } from "../../../../Payments/config";
import { getStatusDisplayText } from "../ChangeRequestList";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: "none",
  textTransform: "capitalize",
}));

const ChangeRequestPayouts = () => {
  const [searchQuery, setSearchQuery] = useSearchParams();
  const [loading, setLoading] = useState();
  const [data, setData] = useState();

  const changeId = searchQuery.get("change");

  const fetchDetails = async () => {
    try {
      setLoading(true);
      const data = await getApiData(
        Setting.endpoints.changeRequest.payouts(changeId),
        "GET",
        {},
        {},
        true
      );
      setData(data);
    } catch (err) {
      toast.error(err.message || "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (changeId) {
      fetchDetails();
    }
  }, [changeId]);
  return (
    <TableContainer
      component={Paper}
      sx={{
        width: "100%",
        overflow: "visible",
        boxShadow: "none",
        marginTop: "2vh",
      }}
    >
      <Table
        sx={{
          "& thead": {
            "& th": {
              color: "#949DAA",
              fontWeight: "500",
            },
          },
          "& tbody": {
            "& tr:hover": {
              backgroundColor: "#f7f7f7",
            },
            "& tr": {
              borderBottom: "none",
            },
          },
        }}
      >
        <TableHead>
          <TableRow>
            <StyledTableCell>Pay To</StyledTableCell>
            {/* <StyledTableCell>Milestone</StyledTableCell> */}
            <StyledTableCell>Payment Group</StyledTableCell>
            <StyledTableCell>Due Date</StyledTableCell>

            <StyledTableCell sx={{ flex: 0.5, textAlign: "right" }}>
              <strong
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                Amount Paid ({renderCurrencyIcon('small')})
              </strong>
            </StyledTableCell>
            <StyledTableCell>Payment Date</StyledTableCell>
            <StyledTableCell>Status</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.payouts?.map((item) => (
            <TableRow key={`budget-${item.referenceId}`}>
              <StyledTableCell>{item?.payeeName || "-"}</StyledTableCell>

              <StyledTableCell>{"-"}</StyledTableCell>
              <StyledTableCell style={{ color: "GrayText" }}>
                {item?.dueDate
                  ? moment(item?.dueDate, "YYYY-MM-DD").format("MMM DD, YYYY")
                  : "-"}
              </StyledTableCell>
              <StyledTableCell style={{ textAlign: "right" }}>
                {item?.amount ? formattedAmountWithoutAed(item?.amount) : "-"}
              </StyledTableCell>
              <StyledTableCell>{"-"}</StyledTableCell>
              <StyledTableCell>
                {item.status !== "CREATED" ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      style={{
                        width: "15px",
                        height: "15px",
                        borderRadius: "50%",
                        backgroundColor:
                          statusStyleArray.find(
                            (style) => style.status === item?.status
                          )?.backgroundColor || "transparent",
                        border: "3px solid #e5e5e5",
                      }}
                    />
                    <Typography
                      style={{
                        fontSize: "14px",
                        marginLeft: "8px",
                        color: "#0D0D0E",
                      }}
                    >
                      {getStatusDisplayText(item?.status)}
                    </Typography>
                  </div>
                ) : (
                  "-"
                )}
              </StyledTableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {data?.totalAmount && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: "4px",
            padding: "16px",
            fontWeight: "500",
            color: "#0D0D0E",
            fontSize: "14px",
          }}
        >
          <div>Total Amount: </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <DhiramIcon height={12} />
            {formattedAmountWithoutAed(data?.totalAmount)}
          </div>
        </Box>
      )}
    </TableContainer>
  );
};

export default ChangeRequestPayouts;
